<template>
  <el-dialog title="请选择结算止期" width="1100px" class="my-dialog-template" :visible.sync="visible" top="0">
    <div class="title-box" slot="title">
      <span class="el-dialog__title">请选择结算止期</span>
      <el-popover placement="top" trigger="hover" popper-class="back-popover">
        <div class="popover-text">选择后，将筛选出在此时间之前的所有可提现期数，合并提现。</div>
        <span slot="reference" class="wenhao">?</span>
      </el-popover>
      <el-date-picker v-model="balanceDateEnd" placeholder="选择日期" value-format="yyyy-MM-dd" @change="getDetailData()"></el-date-picker>
    </div>
    <!-- div模拟表格 -->
    <div class="custom-table" v-loading="listLoading">
      <!-- 表头 -->
      <div class="custom-table__header">
        <div class="custom-table__cell" style="min-width: 160px">结算日期</div>
        <div class="custom-table__cell" style="min-width: 120px" v-if="detailData.needProductAgreementIncomeTax * 1">保险公司</div>
        <div class="custom-table__cell" style="min-width: 120px">结算类型</div>
        <div class="custom-table__cell" style="min-width: 100px">期数</div>
        <div class="custom-table__cell" style="min-width: 120px">总保费（元）</div>
        <div class="custom-table__cell" style="min-width: 100px">保单数</div>
        <div class="custom-table__cell" style="min-width: 140px">应结费用（元）</div>
        <div class="custom-table__cell" style="min-width: 140px">实际收入（元）</div>
      </div>
      <!-- 提示1：暂不支持提现 -->
      <div class="custom-table__tip custom-table__tip--warning" v-if="detailData.needProductAgreementIncomeTax * 1">
        <span class="warning-info">暂不支持提现{{ detailData.needProductAgreementIncomeTax }}元，需签署产品补充协议。</span>
      </div>
      <!-- 数据列表1 -->
      <div class="custom-table__body" v-for="(row, index) in detailData.needProductAgreement" :key="'list1-' + index">
        <div class="custom-table__cell" style="min-width: 160px">{{ row.balanceDate || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 120px" v-if="detailData.needProductAgreementIncomeTax * 1">{{ row.companyName || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 120px">{{ all.BALANCE_TYPE[row.type] || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 100px">{{ row.num || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 120px">{{ row.policyFeeSum || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 100px">{{ row.policyNum || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 140px">
          <span>{{ row.policyIncomes }}</span>
          <activityTip v-if="row.activityIncomes * 1" activityName="含无门槛活动奖励" :subsidyIncomes="row.activityIncomes"></activityTip>
        </div>
        <div class="custom-table__cell" style="min-width: 140px">{{ row.incomeTax || '--' }}</div>
      </div>
      <!-- 提示2：正常合并提现 -->
      <div class="custom-table__tip custom-table__tip--success" v-if="detailData.needProductAgreementIncomeTax * 1 && detailData.normalIncomeTax * 1">
        正常合并提现 {{ detailData.normalIncomeTax }}元
      </div>
      <!-- 数据列表2 -->
      <div class="custom-table__body" v-for="(row, index) in detailData.normal" :key="'list2-' + index">
        <div class="custom-table__cell" style="min-width: 160px">{{ row.balanceDate || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 120px" v-if="detailData.needProductAgreementIncomeTax * 1">{{ row.companyName || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 120px">{{ all.BALANCE_TYPE[row.type] || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 100px">{{ row.num || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 120px">{{ row.policyFeeSum || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 100px">{{ row.policyNum || '--' }}</div>
        <div class="custom-table__cell" style="min-width: 140px">
          <span>{{ row.policyIncomes }}</span>
          <activityTip v-if="row.activityIncomes * 1" activityName="含无门槛活动奖励" :subsidyIncomes="row.activityIncomes"></activityTip>
        </div>
        <div class="custom-table__cell" style="min-width: 140px">{{ row.incomeTax || '--' }}</div>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button type="warning" plain @click="visible = false">取消</el-button>
      <el-button
        type="warning"
        class="bgBtn"
        @click="openUploadAgreementModal()"
        v-if="detailData.needProductAgreement && detailData.needProductAgreement.length"
        >上传补充协议</el-button
      >
      <el-button type="warning" class="bgBtn" @click="submit()" v-if="detailData.normal && detailData.normal.length">合并提现</el-button>
    </div>
  </el-dialog>
</template>
<script>
import topSearchForm from '@/components/topSearchForm';
import activityTip from '@/components/activityTip';
export default {
  components: {
    topSearchForm,
    activityTip
  },
  data: () => ({
    visible: false,
    listLoading: false,
    all: {},
    balanceDateEnd: '',
    detailData: {}
  }),
  created() {
    this.all = this.$tools.getLocal('all');
    const user = this.$tools.getLocal('userinfo');
    this.mechanUserType = user.mechanUserType; //1机构2，3个人
  },
  methods: {
    open() {
      this.balanceDateEnd = '';
      this.visible = true;
      this.getDetailData();
    },
    getDetailData() {
      this.listLoading = true;
      this.$http({
        url: '/master/means/getNotAppliedBalances',
        type: 'get',
        params: {
          balanceDateEnd: this.balanceDateEnd || ''
        }
      }).then(res => {
        this.listLoading = false;
        this.detailData = res.data;
      });
    },
    //提交
    submit() {
      const idList = this.detailData.normal.map(item => item.balanceId);
      this.$emit('submit', {
        balanceIds: idList
      });
      this.visible = false;
    },
    // 自定义请求方式
    setRequstType() {
      return 'GET';
    },
    // 设置自定义参数
    setListParams(params) {
      params.pageSize = 999;
      this.$tools.delNull(params);
    },
    // 打开上传补充协议弹窗
    openUploadAgreementModal() {
      this.visible = false;
      const ids = this.detailData.needProductAgreement.map(item => item.balanceId);
      this.$emit('uploadAgreement', ids);
    }
  }
};
</script>
<style lang="scss" scoped>
.my-dialog-template /deep/ {
  display: flex;
  align-items: center;
  /* div模拟表格样式 */
  .custom-table {
    max-height: calc(100vh - 400px);
    overflow-y: auto;
    border: 1px solid #ebeef5;
    border-bottom: none;
    text-align: center;
  }
  /* 表头 */
  .custom-table__header {
    display: flex;
    background: #f7f7f7;
    position: sticky;
    top: 0;
    z-index: 5;
    border-bottom: 1px solid #ebeef5;
  }
  .custom-table__header .custom-table__cell {
    color: #888888;
    font-size: 14px;
    font-weight: normal;
  }
  /* 数据行 */
  .custom-table__body {
    display: flex;
    border-bottom: 1px solid #ebeef5;
  }
  .custom-table__body .custom-table__cell {
    color: #333333;
    font-size: 14px;
  }
  /* 单元格通用 */
  .custom-table__cell {
    padding: 10px 8px;
    flex-shrink: 0;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-right: 1px solid #ebeef5;
  }
  .custom-table__cell:last-child {
    border-right: none;
    flex: 1;
  }
  /* 提示行 */
  .custom-table__tip {
    padding: 0 16px;
    font-size: 13px;
    border-bottom: 1px solid #ebeef5;
  }
  /* 警告提示样式 - 参考xy-box */
  .custom-table__tip--warning {
    display: flex;
    align-items: center;
    height: 36px;
    line-height: 36px;
    background: #fff8f0;
    .warning-info {
      color: #fd6e06;
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  /* 成功提示样式 */
  .custom-table__tip--success {
    color: #67c23a;
    background: #f0f9eb;
    height: 36px;
    line-height: 36px;
  }
  .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
  }
  .jgheader {
    margin-bottom: 20px;
    .el-input {
      width: 300px;
      margin-right: 20px;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
  .dialog-footer {
    margin-top: 30px;
  }
  .yichang {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: #fff;
    border: 1px solid #ccc;
    color: #ccc;
    display: inline-block;
    text-align: center;
    line-height: 15px;
    font-size: 14px;
    cursor: pointer;
  }
  .title-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .wenhao {
      margin-left: 3px;
      width: 15px;
      height: 15px;
      border-radius: 15px;
      background: #fff;
      border: 1px solid #ccc;
      color: #ccc;
      display: inline-block;
      text-align: center;
      line-height: 15px;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
      display: block;
    }
  }
}
</style>
